import * as signalR from "@microsoft/signalr";
import { getHeaders } from "../Api/common";

class SignalRService {
  constructor() {
    this.connection = null;
    this.connectionId = null;
    this.statusCheckInterval = null;
    this.onMuteMe = null;
  }

  async connect(
    callerId,
    userId,
    isInitiator = true,
    extUserName = null,
    extUserAgoraUid = null
  ) {
    // 先断开已有连接
    if (this.connection) {
      await this.disconnect();
    }

    let connectionUrl = `${
      process.env.REACT_APP_API_ORIGIN
    }/notify?is_initiator=${isInitiator ? "true" : "false"}`;

    if (callerId) connectionUrl += `&caller_id=${callerId}`;
    if (userId) connectionUrl += `&user_id=${userId}`;
    if (extUserName)
      connectionUrl += `&ext_user_name=${encodeURIComponent(extUserName)}`;

    if (extUserAgoraUid !== null && extUserAgoraUid !== undefined)
      connectionUrl += `&ext_user_agora_uid=${extUserAgoraUid}`;

    console.log("Connecting to SignalR:", connectionUrl);

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(connectionUrl)
      .withAutomaticReconnect([0, 2000, 5000, 10000, 15000, 30000])
      .configureLogging(signalR.LogLevel.Information)
      .build();

    this.connection.on("OnToggleMute", (mute) => {
      if (this.onMuteMe) this.onMuteMe(mute);
    });

    // 注册基本事件处理
    this.connection.on("ReceiveMessage", (message) => {
      console.log("SignalR Message Received:", message);
    });

    try {
      await this.connection.start();
      console.log("SignalR Connected!");
      this.connectionId = this.connection.connectionId;
      console.log("Connection ID:", this.connectionId);
      return true;
    } catch (error) {
      console.error("SignalR Connection Error:", error);
      return false;
    }
  }

  registerOnMuteMe(handler) {
    this.onMuteMe = handler;
  }

  toggleMute(targetConnectionId, mute) {
    if (!this.connection) return;
    return this.connection.invoke("ToggleMute", targetConnectionId, mute);
  }

  // 启动定期检查通话状态
  startStatusCheck(callerId, userId, deviceId, callback) {
    this.stopStatusCheck();

    this.statusCheckInterval = setInterval(async () => {
      try {
        const qs = new URLSearchParams();
        qs.append("caller_id", callerId);
        if (userId != null && userId !== "") qs.append("user_id", userId);
        if (deviceId != null && deviceId !== "")
          qs.append("device_id", deviceId);

        const url = `${
          process.env.REACT_APP_DEVICE_API_URL
        }/portal_call_status?${qs.toString()}`;

        const response = await fetch(url, {
          method: "GET",
          headers: getHeaders(),
          credentials: "include",
        });

        if (response.ok) {
          const statusData = await response.json();

          if (
            "active" in statusData &&
            callback &&
            typeof callback === "function"
          ) {
            const isActive = Boolean(statusData.active);
            
            callback(isActive);
          }
        } else {
          console.error("Error checking call status:", response.status);
          const errorText = await response.text();
          console.error("Error response:", errorText);
        }
      } catch (error) {
        console.error("Failed to check call status:", error);
      }
    }, 5000); // 每5秒检查一次
  }

  stopStatusCheck() {
    if (this.statusCheckInterval) {
      clearInterval(this.statusCheckInterval);
      this.statusCheckInterval = null;
    }
  }

  async disconnect() {
    this.stopStatusCheck();

    if (
      this.connection &&
      this.connection.state === signalR.HubConnectionState.Connected
    ) {
      try {
        await this.connection.stop();
        console.log("SignalR Disconnected");
        this.connection = null;
        this.connectionId = null;
        return true;
      } catch (error) {
        console.error("Error disconnecting SignalR:", error);
        return false;
      }
    }
    return true;
  }
}

// 创建单例实例
const signalRService = new SignalRService();
export default signalRService;
